import Vue from 'vue';
import productTagTransformer from './../../transformers/productTag';
import store from './../../store';

const success = ({ data }) => productTagTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const productTags = store.state.productTag.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (productTags.length > 0) {
      return resolve(productTags[0]);
    }

    return Vue.$http.get(`/product_tags/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productTag/show.js